import inflection from 'inflection'
import { takeEvery, all, call, fork, put, takeLatest, select } from 'redux-saga/effects'

import { crudGetList, crudGetOne, downloadTemplate } from '@/state/actions/data'
import { getCurrentRecordId } from '@/state/selectors'
import { getListParams } from '@/state/selectors'
import { GET_ONE_SUCCESS, CHECK_TEMPLATE } from '@/state/types/data'
import { showNotification } from '@/state/actions/notification'
import download from '@/ui/Download'
/*
 * Load hasOne relations from the resource - map all the provided resources
 * and call only valid numbers with crudGetOne action (with disabled cancelPrevious)
 */
function* loadRelations(resources, { type, requestPayload, error, payload }) {
  yield all(
    resources.map(resource => {
      const resourceId = payload.data[`${inflection.singularize(resource)}_id`]
      return Number.isInteger(resourceId) && put(crudGetOne(resource, resourceId, false))
    }),
  )
}

/*
 * Load resource list
 */
function* getList(resource, withPaging) {
  const params = yield select(getListParams(resource))
  yield put(crudGetList(params[0], withPaging ? params[1] : false, params[2], params[3], false))
}

/*
 * Load related resources from the route
 */
function* onRelations(routesMap, action) {
  const currentRoute = routesMap[action.type]
  yield all(currentRoute.relations.map(resource => getList(resource)))
}

/*
 * Load main linked resource from the route
 */
function* onRest(routesMap, action) {
  const id = yield select(getCurrentRecordId)
  const currentRoute = routesMap[action.type]
  // Single view saga
  if (id) {
    yield put(crudGetOne(currentRoute.resource, id))
    if (currentRoute.hasOne) {
      // Trigger loading of the related resource when request succed
      // Check the action for success and verify if resource is equal ro requested one
      yield takeEvery(
        action =>
          action.type === GET_ONE_SUCCESS &&
          action.meta &&
          action.meta.resource === currentRoute.resource,
        loadRelations,
        currentRoute.hasOne,
      )
    }

    // List view saga
  } else {
    yield call(getList, currentRoute.resource, true)
  }
}

const check = function(id) {
  return fetch(`${process.env.API_URL}/api/build/check/${id}`)
    .then(response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(true)
      } else {
        return Promise.reject(false)
      }
    })
    .catch(error => false)
}

function* onDownload(data) {
  const response = yield call(check, data.payload)
  if (response) {
    yield put(downloadTemplate())
    yield put(showNotification(data.payload, `Downloading mail template: ${data.payload}`))
    download(`${process.env.API_URL}/api/build/download/${data.payload}`, 'preview.html')
  } else {
    yield put(
      showNotification(
        data.payload,
        `Mail template: ${data.payload} doesn't exists,
         check if the record exists and has all the needed parts!`,
      ),
    )
  }
}

/*
 * Load linked saga from route
 */
function* onSaga(routesMap, action) {
  yield fork(routesMap[action.type].saga, action)
}

export default function createSagaWithRouting(initialDispatch, routesMap) {
  const routesWithSaga = Object.keys(routesMap).filter(route => routesMap[route].saga)
  const routesWithRest = Object.keys(routesMap).filter(route => routesMap[route].resource)
  const routesWithRelations = Object.keys(routesMap).filter(route => routesMap[route].relations)

  function* routesRest() {
    yield takeLatest(routesWithRest, onRest, routesMap)
  }

  function* routesRelations() {
    yield takeLatest(routesWithRelations, onRelations, routesMap)
  }

  function* routesSaga() {
    yield takeLatest(routesWithSaga, onSaga, routesMap)
  }

  function* downloadSaga() {
    yield takeLatest(CHECK_TEMPLATE, onDownload)
  }

  return function* sagas() {
    // Trigger rest calls on any route that has resource asigned
    yield fork(routesRest)
    // Trigger rest calls on any route that has related resources asigned
    yield fork(routesRelations)
    // Run any saga that is connected to selected routes when navigating to it
    yield fork(routesSaga)
    // Download saga
    yield fork(downloadSaga)
    // Call first-router initial internal dispatch
    yield call(initialDispatch)
  }
}



// WEBPACK FOOTER //
// ./state/sagas/routes.js